import { createContext } from 'react';

export const rememberScrollPositionDefaultValue = new Map();

// Context that can remember scroll positions (numbers) connected to id's (strings)
const RememberScrollPositionContext = createContext<Map<string, number>>(
	rememberScrollPositionDefaultValue
);

export default RememberScrollPositionContext;
